/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOneBaseAodRulesControllerAodRuleQueryResponse, GetOneBaseAodRulesControllerAodRulePathParams, GetOneBaseAodRulesControllerAodRuleQueryParams } from "../models/GetOneBaseAodRulesControllerAodRule";

export function getGetOneBaseAodRulesControllerAodRuleUrl(id: GetOneBaseAodRulesControllerAodRulePathParams["id"]) {
  const res = { method: 'GET', url: `/aod-rules/${id}` as const }
  return res
}

/**
 * @summary Retrieve a single AodRule
 * {@link /aod-rules/:id}
 */
export async function getOneBaseAodRulesControllerAodRule(id: GetOneBaseAodRulesControllerAodRulePathParams["id"], params?: GetOneBaseAodRulesControllerAodRuleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetOneBaseAodRulesControllerAodRuleQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetOneBaseAodRulesControllerAodRuleUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}